export default {
  loading: false,
  successAccion: false,
  category: {},
  subject: {},
  service: {},
  region: {},
  institution: {},
  activity: {},
  kanbanState: {},
  typeAttachment: {},
  error: '',
  herramientas: {
    mantenedores: {
      categorias: [],
      documentos: {},
      categoryInstitutions: [],
      institutions: [],
      categorySubjects: [],
      subjects: [],
      categoryServices: [],
      services: [],
      categoryRegions: [],
      regions: [],
      categoryActivities: [],
      activityStates: [],
      categoryStates: [],
      categoryTypeAttachments: [],
      subStateStates: [],
      categoryRetentionPercentage: []
    }
  }
};
